import { BrandConfig } from '../models/brand.model';

export const DEFAULT_BRAND: BrandConfig = {
  host: 'default',
  appName: 'Sistema',
  logoMini: 'assets/brands/default/logo-mini.png',
  logoDark: 'assets/brands/default/logo-dark.png',
  logoLight: 'assets/brands/default/logo-light.png',
  logoSm: 'assets/brands/default/logo-sm.png',
  logoLg: 'assets/brands/default/logo-lg.png',
  favicon: 'assets/brands/default/favicon.ico',
  abertoAoPublico: false,
  idCliente: 1,
  contactEmail: 'suporte@ispcloud.com.br',
};

export const BRANDS_CONFIG: Record<string, BrandConfig> = {
  'arqvisio.visiotec.com.br': {
    host: 'arqvisio.visiotec.com.br',
    appName: 'Arq.Visio',
    logoMini: 'assets/images/brands/arqvisio/logo-mini.png',
    logoDark: 'assets/images/brands/arqvisio/logo-dark.png',
    logoLight: 'assets/images/brands/arqvisio/logo-light.png',
    logoSm: 'assets/images/brands/arqvisio/logo-sm.png',
    logoLg: 'assets/images/brands/arqvisio/logo-lg.png',
    favicon: 'assets/images/brands/arqvisio/favicon.ico',
    abertoAoPublico: false,
    idCliente: 1,
    contactEmail: 'visiotec@visiotec.com.br',
  },
  'ged.magiclamp.dev.br': {
    host: 'ged.magiclamp.dev.br',
    appName: 'ISP Cloud',
    logoMini: 'assets/images/brands/storage/logo-mini.png',
    logoDark: 'assets/images/brands/storage/logo-dark.png',
    logoLight: 'assets/images/brands/storage/logo-light.png',
    logoSm: 'assets/images/brands/storage/logo-sm.png',
    logoLg: 'assets/images/brands/storage/logo-lg.png',
    favicon: 'assets/images/brands/storage/favicon.ico',
    abertoAoPublico: false,
    contactEmail: 'suporte@ispcloud.com.br',
    idCliente: 1,
  },
  'localhost': {
    host: 'localhost',
    appName: 'Cloud DEV',
    logoMini: 'assets/images/brands/arqvisio/logo-mini.png',
    logoDark: 'assets/images/brands/arqvisio/logo-dark.png',
    logoLight: 'assets/images/brands/arqvisio/logo-light.png',
    logoSm: 'assets/images/brands/arqvisio/logo-sm.png',
    logoLg: 'assets/images/brands/arqvisio/logo-lg.png',
    favicon: 'assets/images/brands/arqvisio/favicon.ico',
    abertoAoPublico: true,
    idCliente: 1,
    contactEmail: 'visiotec@visiotec.com.br',
  }
};